var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#027BFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 25.25H16.5C16.1458 25.25 15.849 25.1302 15.6094 24.8906C15.3698 24.651 15.25 24.3542 15.25 24C15.25 23.6458 15.3698 23.349 15.6094 23.1094C15.849 22.8698 16.1458 22.75 16.5 22.75H22.75V16.5C22.75 16.1458 22.8698 15.849 23.1094 15.6094C23.349 15.3698 23.6458 15.25 24 15.25C24.3542 15.25 24.651 15.3698 24.8906 15.6094C25.1302 15.849 25.25 16.1458 25.25 16.5V22.75H31.5C31.8542 22.75 32.151 22.8698 32.3906 23.1094C32.6302 23.349 32.75 23.6458 32.75 24C32.75 24.3542 32.6302 24.651 32.3906 24.8906C32.151 25.1302 31.8542 25.25 31.5 25.25H25.25V31.5C25.25 31.8542 25.1302 32.151 24.8906 32.3906C24.651 32.6302 24.3542 32.75 24 32.75C23.6458 32.75 23.349 32.6302 23.1094 32.3906C22.8698 32.151 22.75 31.8542 22.75 31.5V25.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.3c52fb4ebc239c6fc2483d4d7d945c8d.svg";
export { ForwardRef as ReactComponent };